<template>
    <div class="curtain-grey" :style="{backgroundColor: moduleState.bodyState ? 'rgba(0, 0, 0, 0.2)':'rgba(0, 0, 0, 0)'}">
        <OptionCategory  v-if="moduleState.categoryState"
                         :categoryId="currentCategory.categoryId"
                         @submitEvent="saveCategory($event)"
                         @closeEvent="switchState('categoryState')"/>
        <SettingDateTime v-if="moduleState.dateTimeState"
                     :startDate="currentDateTime.startDate"
                     :crossEndDate="currentDateTime.crossEndDate"
                     :startTime="currentDateTime.startTime"
                     :endTime="currentDateTime.endTime"
                     :allowCross="allowCross"
                     @closeEvent="switchState('dateTimeState')"
                     @submitEvent="saveDateTime($event)"
        />
        <SettingRemind v-if="moduleState.remindState"
                       :startDate="currentDateTime.startDate"
                       :startTime="currentDateTime.startTime"
                       :remindTimes="currentRemind.remindTimes"
                       :userRole="vipInfo.userRole"
                       @closeEvent="switchState('remindState')"
                       @submitEvent="saveRemind($event)"
        />
        <SettingRepeat v-if="moduleState.repeatState"
                       :startDate="currentDateTime.startDate"
                       :repeatType="currentRepeat.repeatType"
                       :repeatCycle="currentRepeat.repeatCycle"
                       :repeatInfo="currentRepeat.repeatInfo"
                       :skipHolidaysState="currentRepeat.skipHolidaysState"
                       @submitEvent="saveRepeat($event)"
                       @closeEvent="switchState('repeatState')"
        />
        <SettingRepeatEnd v-if="moduleState.repeatEndState"
                          :repeatEndType="currentRepeatEnd.repeatEndType"
                          :repeatEndInfo="currentRepeatEnd.repeatEndInfo"
                          @submitEvent="saveRepeatEnd($event)"
                          @closeEvent="switchState('repeatEndState')"
        />
        <OptionPriority v-if="moduleState.priorityState"
                        :priorityItems="priorityItems"
                        :priorityLevel="currentPriority.priorityLevel"
                        @submitEvent="savePriority($event)"
                        @closeEvent="switchState('priorityState')"/>

        <OptionColor ref="optionColor" v-if="moduleState.colorState"
                     :hexColor="currentViewColor.hexColor"
                     @submitEvent="saveViewColor($event)"
                     @closeEvent="switchState('colorState')"/>

        <DeleteCard v-if="moduleState.deleteState"
                      :moduleTitle="deleteTitle"
                      :repeatState="matterItem.info.iconIsRepeat"
                      @submitEvent="saveDelete($event)"
                      @closeEvent="switchState('deleteState')"/>
        <UpdateCard v-if="moduleState.updateState"
                    @submitEvent="saveUpdate($event)"
                    @closeEvent="switchState('updateState')"/>
        <div class="body-matter-info">
            <div class="info-title">
                <img class="icon-back my-cursor" src="../../../assets/images/Login/icon-back.png" alt="" @click.stop="close">
                <div class="item-category my-cursor" @click.stop="switchState('categoryState')">
                    <div class="text-category">
                        <template v-if="currentCategory.categoryId === ''">无分类</template>
                        <template v-else>{{ currentCategory.categoryTitle }}</template>
                    </div>
                    <img class="icon-put-open" src="../../../assets/images/List/icon-put-open.png" alt="" >
                </div>
            </div>
            <div class="scroll-items">
                <div class="matter-title">
                    <label>
                        <input class="matter-title"
                               v-model="currentTitle.text"
                               maxlength="150"
                               @blur="saveTitle()"
                               placeholder="输入清单标题" type="text">
                    </label>
                </div>
                <div class="setting-items">
                    <div class="item-setting my-cursor" @click.stop="switchState('dateTimeState')">{{ currentDateTime.text }}</div>
                    <div class="item-setting my-cursor" @click.stop="switchState('remindState')">{{ currentRemind.text }}</div>
                    <div class="item-setting my-cursor" v-show="currentDateTime.crossEndDate === ''" @click.stop="switchState('repeatState')">
                        {{ currentRepeat.text }}</div>
                    <div class="item-setting my-cursor" v-show="currentRepeat.repeatType !== ''" @click.stop="switchState('repeatEndState')">
                        {{ currentRepeatEnd.text }}</div>
                </div>
                <div class="matter-child">
                    <div class="row-child-item"
                         v-show="childItem.dataAction!== 'delete'"
                         v-for="(childItem, childIndex) in currentChild.items">
                        <img class="item-icon" src="../../../assets/images/List/icon-info-child.png" alt="">
                        <label>
                            <input class="child-title"
                                   :value="childItem.title"
                                   @blur="saveChildItem($event, childItem)"
                                   placeholder="添加子任务" type="text">
                        </label>
                        <img src="../../../assets/images/List/icon-delete.png" alt=""
                             class="item-icon child-delete my-cursor" @click.stop="deleteChild(childItem, childIndex)">
                    </div>
                    <div class="row-child-item">
                        <img class="item-icon" src="../../../assets/images/List/icon-info-add.png" alt="">
                        <label>
                            <input ref="child-add"
                                    class="child-title"
                                   @keyup.stop="setChildKeyUp($event)"
                                   v-model="currentChild.title"
                                   placeholder="添加子任务" type="text">
                        </label>
                        <div class="child-submit my-cursor"
                             @click.stop="addChildItem()"
                             v-show="currentChild.title !==''">完成</div>
                    </div>
                </div>
                <div class="matter-priority">
                    <img src="../../../assets/images/List/icon-info-priority.png" alt="" class="item-icon">
                    <div class="text-title">优先级</div>
                    <div class="text-priority my-cursor"
                         @click.stop="switchState('priorityState')">
                        {{ priorityItems[currentPriority.priorityLevel - 1] }}
                        <img src="../../../assets/images/List/icon-put-away.png" alt="" class="icon-put-away">
                    </div>
                </div>
                <div class="matter-view-color">
                    <img src="../../../assets/images/List/icon-info-color.png" alt="" class="item-icon">
                    <div class="text-title">视图颜色</div>
                    <div class="matter-color my-cursor"
                         @click.stop="switchState('colorState')">
                        <div class="view-color" :style="{backgroundColor: currentViewColor.hexColor}"></div>
                        <img src="../../../assets/images/List/icon-put-away.png" alt="" class="icon-put-away">
                    </div>
                </div>
                <div class="matter-mark">
                    <label>
                    <textarea name="matter-mark" id="matter-mark" v-model="currentNotes.text"
                              @blur="saveNotes()"
                              placeholder="添加详细描述" maxlength="500"></textarea>
                    </label>
                    <div class="image-add-tip my-cursor"
                         @click.stop="openAddImage()"
                         v-show="currentImages.imageFiles.length === 0">
                        <img class="icon-add-tip" src="../../../assets/images/List/icon-info-add.png" alt="">
                        添加图片
                    </div>
                    <div class="mark-images" v-show="currentImages.imageFiles.length > 0">

                        <div class="image-add my-cursor"
                             v-show="currentImages.imageFiles.length < 5"
                             @click.stop="openAddImage()">
                            <div class="icon-image-add"></div>
                            <input ref="image-add" style="display: none" type="file" @change.stop="getImageFile($event)" accept="image/*">
                        </div>

                        <div class="item-image"
                             @mouseover="mouseOverImage(imgIndex)"
                             @mouseout="mouseOutImage()"
                             v-for="(imgItem, imgIndex) in currentImages.imageFiles">
                            <el-image
                                    style="width: 0.54rem;
                                        height: 0.54rem;
                                        border-radius: 0.08rem;
                                        float: left;
                                        "
                                    :fit="'cover'"
                                    :src="imgItem"
                                    :preview-src-list="currentImages.imageFiles">
                            </el-image>
                            <div class="icon-image-delete my-cursor" :style="{'visibility': currentImages.mouseImageIndex === imgIndex ? 'visible':'hidden'}"
                                 @click.stop="setImages(1, imgItem)"></div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="bottom-items">
                <div class="item-submit my-cursor"
                     @click.stop="inquiryDelete"
                     v-show="this.matterItem.info">删除清单</div>
                <div class="item-submit my-cursor" @click.stop="saveInfo">保存清单</div>
            </div>
        </div>
    </div>
</template>

<script>
import OptionCategory from "./OptionCategory";
import SettingDateTime from "./SettingDateTime";
import SettingRemind from "./SettingRemind";
import SettingRepeat from "./SettingRepeat";
import SettingRepeatEnd from "./SettingRepeatEnd";
import OptionPriority from "./OptionPriority";
import OptionColor from "./OptionColor";
import DeleteCard from "../ColumnMatter/DeleteCard";
import UpdateCard from "./UpdateCard";


import { mapState, mapMutations } from "vuex";
import listRemindFormat from "@/utils/List/listRemindFormat";
import listEndDate from "@/utils/List/listEndDate";
import initData from  "@/utils/initData";
export default {
    name: "MatterInfo",
    components: {
        OptionCategory,
        SettingDateTime,
        SettingRemind,
        SettingRepeat,
        SettingRepeatEnd,
        OptionPriority,
        OptionColor,
        DeleteCard,
        UpdateCard
    },
    data(){
        return {
            moduleState: {
                bodyState: true,
                categoryState: false,
                priorityState: false,
                colorState: false,
                dateTimeState: false,
                remindState: false,
                repeatState: false,
                repeatEndState: false,

                deleteState: false,
                updateState: false,
            },
            priorityItems: ["重要且紧急", "重要不紧急", "紧急不重要", "不重要不紧急"],
            currentMatter: {},
            currentLine: null,
            deleteTitle: "子任务",
            createState: true,
            allowCross: true,
            sortNum: 10,
            inventoryId: "",

            currentTitle: {
                updated: false,
                text: "",
            },
            currentDateTime: {
                updated: false,
                startDate: "",
                crossEndDate: "",
                crossDays: 0,
                startTime: -1,
                endTime: -1,
                text: "设置时间",
            },
            currentRemind: {
                updated: false,
                remindTimes: "",
                remindType: 0,
                text: "设置提醒",
            },
            currentRepeat: {
                updated: false,
                repeatType: "",
                repeatCycle: 1,
                repeatInfo: "",
                skipHolidaysState: false,
                text: "设置重复",
            },
            currentRepeatEnd: {
                updated: false,
                repeatEndType: "",
                repeatEndInfo: "",
                endDate: "",
                text: "永不结束",
            },
            currentCategory: {
                updated: false,
                categoryId: "",
                categoryTitle: "",
            },
            currentChild: {
                updated: false,
                title: "",
                items: [],
            },
            currentPriority: {
                updated: false,
                priorityLevel: 4,
            },
            currentViewColor: {
                updated: false,
                hexColor: "",
                numberColor: 0,
            },
            currentNotes: {
                updated: false,
                text: "",
            },
            currentImages: {
                mouseImageIndex: -1,
                imageUrls: "",
                imageFiles: [],
                imageItems: [],
            },
        }
    },
    props: {
        waitState: {
            type: Boolean,
            default: false,
        },
        clockTargetDate: {
            type: String,
            default: "",
        },

        matterItem: {
            type: Object,
            default: ()=>{},
        },
    },
    computed: {
        ...mapState(["userId", "vipInfo"]),
        ...mapState("listModules", ["optId","tbListInfo", "tbListLine", "tbListChild"])
    },

    methods: {
        ...mapMutations("listModules", ["setOptId", "setLoading", "setList", "setLine", "setChild", "setDeleteData"]),
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            this.$emit("submitEvent");
        },
        switchState: function(moduleName){
            this.moduleState[moduleName] = !this.moduleState[moduleName];
            this.moduleState.bodyState = !this.moduleState[moduleName];
        },
        initSettingInfo: function(){
            //
            this.tbListInfo.forEach((item)=>{
                if(item.inventoryId === this.matterItem.info.inventoryId){
                    this.currentMatter = JSON.parse(JSON.stringify(item));
                }
            })

            if(this.matterItem.lineInfo.startDate !== ""){
                // 有子线
                this.tbListLine.filter((item)=>{
                    if(item.linkInventoryId === this.matterItem.info.inventoryId
                        && item.startDate === this.matterItem.lineInfo.startDate
                        && item.dataTape === this.matterItem.lineInfo.dataTape){
                        this.currentLine = JSON.parse(JSON.stringify(item));
                    }
                })
            }
            // 初始化 子线 标题、备注
            this.initNotes();
            // 初始化分类
            this.initCategory(this.currentMatter.categoryId, this.currentMatter.categoryTitle);
            // 初始化日期 时间
            this.initDateTime({
                startDate: this.currentMatter.startDate,
                crossEndDate: this.currentMatter.crossEndDate,
                crossDays: this.currentMatter.crossDays,
                startTime: this.currentMatter.startTime,
                endTime: this.currentMatter.endTime,
            });
            // 初始化 提醒
            this.initRemind(this.currentMatter.remindTimes);
            // 初始化 重复
            this.initRepeat({
                repeatType: this.currentMatter.repeatType,
                repeatCycle: this.currentMatter.repeatCycle,
                repeatInfo: this.currentMatter.repeatInfo,
                skipHolidaysState: this.currentMatter.skipHolidaysState,
            });
            this.initRepeatEnd({
                repeatEndType: this.currentMatter.repeatEndType,
                repeatEndInfo: this.currentMatter.repeatEndInfo,
                endDate: this.currentMatter.endDate,
            });
            // 初始化子任务
            this.initChild();
            // 初始化优先级
            this.currentPriority.priorityLevel = this.currentMatter.priorityLevel;
            // 视图颜色
            this.currentViewColor.hexColor = "#" + (this.currentMatter.color.toString(16).slice(2)).toUpperCase();
            this.currentViewColor.numberColor = this.currentMatter.color;
            // 图片
            this.initImageFiles();
        },
        // 初始化分类
        initCategory: function(categoryId, categoryTitle){
            this.currentCategory.categoryId = categoryId;
            this.currentCategory.categoryTitle = categoryTitle;
        },
        initDateTime: function(dateItem){
            let text;
            if(dateItem.startDate === ""){
                // 全天
                text = "设置时间";
            }else if(dateItem.crossEndDate ===""){
                // 日期
                text = this.$Utils.getDateStr(dateItem.startDate);

                if(dateItem.startTime > -1){
                    const startTime = this.$Utils.minuteToTime(dateItem.startTime);
                    text = text + " " + startTime.hour+ ":" + startTime.minute;
                }
                if(dateItem.endTime > -1){
                    const endTime = this.$Utils.minuteToTime(dateItem.endTime);
                    text = text + "-" + endTime.hour+ ":" + endTime.minute;
                }

            }else{
                // 跨天
                text = this.$Utils.getDateStr(dateItem.startDate);
                if(dateItem.startTime > -1){
                    const time = this.$Utils.minuteToTime(dateItem.startTime);
                    text = text + time.hour + ":" + time.minute;
                }
                text = text + "-" + this.$Utils.getDateStr(dateItem.crossEndDate);
                if(dateItem.endTime > -1){
                    const time = this.$Utils.minuteToTime(dateItem.endTime);
                    text = text + time.hour + ":" + time.minute;
                }
            }

            this.currentDateTime.startDate = dateItem.startDate;
            this.currentDateTime.crossEndDate = dateItem.crossEndDate;
            this.currentDateTime.crossDays = dateItem.crossDays;
            this.currentDateTime.startTime = dateItem.startTime;
            this.currentDateTime.endTime = dateItem.endTime;
            this.currentDateTime.text = text;
        },
        initRemind: function(remindTimes){
            let text, remindType;

            if (this.currentDateTime.startDate === "") {
                // 待办
                remindType = 0;
            } else if (this.currentDateTime.startTime === -1) {
                // 全天
                remindType = 1;
            } else {
                // 时间点
                remindType = 2;
            }

            if(remindTimes === ""){
                text = "设置提醒";
            }else {
                const remindItems = remindTimes.split(",");
                remindItems.forEach((item, index, array) => {
                    item = parseInt(item);
                    let itemText;
                    if (remindType === 0 ) {
                        // 待办
                        itemText = listRemindFormat.getWaitDate(item);
                    } else if (remindType === 1) {
                        // 全天
                        itemText = listRemindFormat.getAllDate(item);
                    } else {
                        // 时间点
                        itemText = listRemindFormat.getTimeDate(item);
                    }
                    array[index] = itemText;
                })
                text = remindItems.join("、");
            }
            this.currentRemind.text = text;
            this.currentRemind.remindTimes = remindTimes;
            this.currentRemind.remindType = remindType;
        },
        initRepeat: function(repeatItem){
            let text, targetDate;
            targetDate = Solar.fromDate(new Date(this.currentDateTime.startDate));

            if(repeatItem.repeatType === ""){
                text = "设置重复";
            }else if(repeatItem.repeatType === "every_day"){
                text = "每天";
            }else if(repeatItem.repeatType === "every_week"){
                text = "每周" + targetDate.getWeekInChinese();
            }else if(repeatItem.repeatType === "work_day"){
                text = "法定工作日(不包含法定节日、假日)";
            }else if(repeatItem.repeatType === "every_month"){
                text = "每月(" + targetDate.getDay() + "日)";
            }else if(repeatItem.repeatType === "every_year"){
                text = "每年(" + targetDate.getMonth() + "月" + targetDate.getDay() + "日)";
            }else if(repeatItem.repeatType === "lunar_year"){
                const lunarDate = targetDate.getLunar();
                text = "农历" + lunarDate.getMonthInChinese() + "月" + lunarDate.getDayInChinese();
            }else if(repeatItem.repeatType === "i_b_h_s"){
                text = "艾宾浩斯记忆";
            }else{
                text = "自定义重复";
            }
            this.currentRepeat.repeatType = repeatItem.repeatType;
            this.currentRepeat.repeatCycle = repeatItem.repeatCycle;
            this.currentRepeat.repeatInfo = repeatItem.repeatInfo;
            this.currentRepeat.skipHolidaysState = repeatItem.skipHolidaysState;
            this.currentRepeat.text = text;
        },
        initRepeatEnd: function(repeatEndItem){
            let text;
            if(repeatEndItem.repeatEndType === ""){
                text = "永不结束"
            }else if(repeatEndItem.repeatEndType === "date"){
                text = repeatEndItem.repeatEndInfo + "结束重复";
            }else{
                text = "重复" + repeatEndItem.repeatEndInfo + "次结束";
            }

            this.currentRepeatEnd.repeatEndType = repeatEndItem.repeatEndType;
            this.currentRepeatEnd.repeatEndInfo = repeatEndItem.repeatEndInfo;
            this.currentRepeatEnd.endDate = repeatEndItem.endDate;
            this.currentRepeatEnd.text = text;
        },
        initChild: function(){
            let items = this.tbListChild.filter((item)=>{
                return item.linkInventoryId === this.currentMatter.inventoryId
            });
            items.sort((nextItem, item)=>{
                return item.sortNum - nextItem.sortNum
            })
            this.currentChild.items = JSON.parse(JSON.stringify(items));
        },

        initNotes: function(){
            if(this.currentLine){
                // 子线
                this.currentTitle.text = this.currentLine.title;
                this.currentNotes.text = this.currentLine.notes;
            }else{
                // 主线
                this.currentTitle.text = this.currentMatter.title;
                this.currentNotes.text = this.currentMatter.notes;
            }

        },

        initImageFiles: function(){
            let noteUrls;
            if(this.currentLine){
                // 子线
                noteUrls = this.currentLine.notesUrls;
            }else{
                // 主线
                noteUrls = this.currentMatter.notesImageUrls;
            }
            if(noteUrls && noteUrls !== ""){
                this.currentImages.imageFiles = noteUrls.split(",");
                this.currentImages.imageFiles.forEach((item)=>{
                    this.currentImages.imageItems.push({
                        state: true,
                        img: item,
                    })
                })
                this.currentImages.imageUrls = noteUrls;
            }
        },
        saveCategory: function(e){
            if(this.currentCategory.categoryId !== e){
                this.initCategory(e.categoryId, e.title);
                this.currentCategory.updated = this.currentMatter.categoryId !== e.categoryId;
            }

        },
        savePriority: function(e){
            if(this.currentPriority.priorityLevel !== e){
                this.currentPriority.priorityLevel = e;
                this.currentPriority.updated = this.currentMatter.priorityLevel !== e;
            }
        },
        saveViewColor: function(e){
            if(this.currentViewColor.hexColor !== e){
                this.currentViewColor.hexColor = e;
                this.currentViewColor.numberColor = parseInt("FF" + e.slice(1).toString(16), 16);
                this.currentViewColor.updated = this.currentMatter.color !== this.currentViewColor.numberColor;
            }
        },
        saveTitle: function(){
            let title;
            if(this.currentLine){
                // 子线
                title = this.currentLine.title;
            }else{
                // 主线
                title = this.currentMatter.title;
            }
            this.currentTitle.updated = this.currentTitle.text !== title;
        },
        saveDateTime: function(e){
            this.initDateTime(e);
            const startDate = this.currentMatter.startDate !== e.startDate;
            const crossEndDate = this.currentMatter.crossEndDate !== e.crossEndDate;
            const startTime = this.currentMatter.startTime !== e.startTime;
            const endTime = this.currentMatter.endTime !== e.endTime;

            this.currentDateTime.updated = startDate || crossEndDate || startTime || endTime;

            if (this.currentDateTime.startDate === "") {
                // 待办日期
                if(this.currentRemind.remindType !== 0){
                    // 非待办提醒 清空提醒
                    this.initRemind("");
                }
                if(this.currentRepeat.repeatType !== ""){
                    // 有重复
                    this.initRepeat({
                        repeatType: "",
                        repeatCycle: 1,
                        repeatInfo: "",
                        skipHolidaysState: false,
                    });
                }
                if(this.currentRepeatEnd.repeatEndType !== ""){
                    // 有重复结束
                    this.initRepeatEnd({
                        repeatEndType: "",
                        repeatEndInfo: "",
                        endDate: "",
                    });
                }
            } else if (this.currentDateTime.startTime === -1) {
                // 全天日期
                if(this.currentRemind.remindType !== 1){
                    // 非全天提醒
                    this.initRemind("");
                }
            } else {
                // 时间点
                if(this.currentRemind.remindType !== 2){
                    // 非全天提醒
                    this.initRemind("");
                }
            }
        },
        saveRemind: function(e){
            this.initRemind(e);
            this.currentRemind.updated = this.currentMatter.remindTimes !== e;
        },
        saveRepeat: function(e){

            this.initRepeat(e);
            const repeatType = this.currentMatter.repeatType !== e.repeatType;
            const repeatCycle = this.currentMatter.repeatCycle !== e.repeatCycle;
            const repeatInfo = this.currentMatter.repeatInfo !== e.repeatInfo;
            const skipHolidaysState = this.currentMatter.skipHolidaysState !== e.skipHolidaysState;
            this.currentRepeat.updated = repeatType || repeatCycle || repeatInfo || skipHolidaysState;

            if(this.currentDateTime.startDate === ""){
                // 待办日期
                const startDate = Solar.fromDate(new Date()).toYmd();
                this.initDateTime({
                    startDate: startDate,
                    crossEndDate: "",
                    crossDays: 0,
                    startTime: -1,
                    endTime: -1,
                });
                // 清空提醒
                this.initRemind("");
            }
            if(this.currentRepeatEnd.repeatEndType !== ""){
                this.initRepeatEnd({
                    repeatEndType: "",
                    repeatEndInfo: "",
                    endDate: "",
                });
            }

        },
        saveRepeatEnd: function(e){
            if(e.repeatEndType === ""){
                e.endDate = "";
            }else if (e.repeatEndType === "date"){
                e.endDate = e.repeatEndInfo;
            }else{
                e.endDate = listEndDate.getEndDate({
                    startDate: this.currentDateTime.startDate,
                    repeatType: this.currentRepeat.repeatType,
                    repeatCycle: this.currentRepeat.repeatCycle,
                    repeatInfo: this.currentRepeat.repeatInfo,
                    endNumber: e.repeatEndInfo
                });
            }
            this.initRepeatEnd(e);

            const repeatEndType = this.currentMatter.repeatEndType !== e.repeatEndType;
            const repeatEndInfo = this.currentMatter.repeatEndInfo !== e.repeatEndInfo;
            this.currentRepeatEnd.updated = repeatEndType || repeatEndInfo;
        },
        setChildKeyUp: function(e){
            if(e.keyCode === 13){
                this.addChildItem()
            }
        },
        addChildItem: function(){
            if (this.currentChild.title.trim() === ""){
                // 提示标题不能为空白字符
                this.$PopupToast("标题为空白字符");
                return
            }
            let sortNum = 10;
            if(this.currentChild.items.length > 0){
                sortNum = this.currentChild.items[0].sortNum + 10;
            }
            this.currentChild.items.push({
                childId: this.$Utils.get_uuid(),
                userId: this.userId,
                linkInventoryId: this.inventoryId,
                title: this.currentChild.title,
                color: this.currentViewColor.numberColor,
                priorityLevel: this.currentPriority.priorityLevel,
                sortNum: sortNum,
                createTimeStamp: Date.now(),
                startDate: "",
                crossEndDate: "",
                crossDays: 0,
                startTime: -1,
                endTime: -1,
                remindTimes: "",
                dataAction: "add",
            })
            this.currentChild.items.sort((nextItem, item)=>{
                return item.sortNum - nextItem.sortNum
            })
            this.currentChild.updated = true;

            this.currentChild.title = "";
            this.$refs["child-add"].focus();
        },

        deleteChild: function(childItem){
            if(childItem.dataAction === "add"){
                this.currentChild.items.forEach((item, index, array)=>{
                    if(item.childId === this.childItem.childId){
                        array.splice(index, 1)
                    }
                })
            }else{
                // 询问
                this.childItem = childItem;
                this.deleteTitle = "子任务";
                this.switchState("deleteState");
            }
            this.currentChild.updated = true;
        },
        saveChildItem: function(e, childItem){
            let value = e.currentTarget.value;
            if(value.trim() === ""){
                e.currentTarget.value = childItem.title;
            }else if(value !== childItem.title){
                childItem.title = value;
                if(childItem.dataAction !== "add"){
                    childItem.dataAction = "update";
                }
            }
            this.currentChild.updated = true;
        },

        saveNotes: function(){
            let notes;
            if(this.currentLine){
                // 子线
                notes = this.currentLine.notes;
            }else{
                // 主线
                notes = this.currentMatter.notes;
            }
            this.currentNotes.updated = this.currentNotes.text !== notes;
        },
        // 光标进入
        mouseOverImage: function(index){
            this.currentImages.mouseImageIndex = index;
        },
        // 光标离开
        mouseOutImage: function(){
            this.currentImages.mouseImageIndex = -1;
        },
        /**
         * 打开添加图片弹窗
         */
        openAddImage: function(){
            if(this.checkMatterImageNumber()){
                // 弹出会员弹窗
                // this.openModule("VipModule");
                this.$PopupToast("非会员上传图片限制1张");
            }else{
                this.$refs['image-add'].click();
            }
        },
        /**
         * 添加图片
         *  1. 上传图片 ——> 云地址
         *  2. 保存云地址 ——> 更新时间线
         *  3. 更新当前图片字段展示
         */
        getImageFile: function(e){
            const that = this;
            let targetNav = e.srcElement;
            let fileData = targetNav.files[0];
            if (fileData.size / 1024 / 1024 > 10){
                // 提示图片过大 > 10MB
                that.$PopupToast("图片大小超过10M");
                return
            }else if(fileData.type.search("image") === -1){
                // 提示文件格式非image
                that.$PopupToast("文件格式错误");
                return
            }
            const imgId = this.$Utils.get_uuid();
            const imgType = fileData.type.replace("image/", "");
            const imgPath = "image/img_listNoteImage/" + that.userId + "/" + imgId + "." + imgType;
            let formData = new FormData();
            formData.append("file", fileData);
            formData.append("filePath", imgPath);
            that.$api.ossPutImage(formData).then((res)=>{
                if(res.data.code === 200){
                    that.setImages(0, "https://tomatofile.incmoon.com/" + imgPath);
                }else{
                    that.$PopupToast("图片上传失败");
                }
            })
        },
        /**
         * 删除图片
         */
        deleteImageFile: function(){
            let pathItems = [];
            this.currentImages.imageItems.forEach((item, index, array)=>{
                if(!item.state){
                    pathItems.push(item.img.replace("https://tomatofile.incmoon.com/", ""));
                }
            })
            if(pathItems.length === 0){
                return
            }
            const params = {
                pathItems: pathItems
            }

            this.$api.ossDeleteImage(params).then((res)=>{
                if(res.data.code === 200){
                }else{
                    console.log("附件删除失败");
                }
            })
        },
        /**
         * 设置备注图片
         * @param setType 0: 添加图片, 1: 删除图片
         * @param imgPath
         */
        setImages: function(setType, imgPath){
            if(setType === 0){
                // 添加图片
                this.currentImages.imageFiles.push(imgPath);
                this.currentImages.imageUrls = this.currentImages.imageFiles.join(",");
                this.currentImages.imageItems.push({
                    state: true,
                    img: imgPath
                })
            }else{
                // 删除图片
                const deleteIndex = this.currentImages.imageFiles.indexOf(imgPath);
                this.currentImages.imageFiles.splice(deleteIndex, 1);
                this.currentImages.imageUrls = this.currentImages.imageFiles.join(",");
                this.currentImages.imageItems.forEach((item, index, array)=>{
                    if(item.img !== imgPath){
                        return
                    }
                    item.state = false;
                })
            }
            this.currentImages.updated = true;
        },

        deleteMatter: function(deleteType){
            const listInfoList = [];
            const listDeleteList = [];
            if(deleteType === 0){
                // 删除当天
                let repeatDeleteDates;
                if(this.currentMatter.repeatDeleteDates === ""){
                    repeatDeleteDates = []
                }else{
                    repeatDeleteDates = this.currentMatter.repeatDeleteDates.split(",");
                }
                repeatDeleteDates.push(this.clockTargetDate);
                this.currentMatter.repeatDeleteDates = repeatDeleteDates.join(",");
                this.currentMatter.dataAction = "update";
                listInfoList.push(this.currentMatter);
            }else if(deleteType === 1){
                // 删除单天及以后
                this.currentMatter.repeatEndType = "date";
                this.currentMatter.repeatEndInfo = Solar.fromDate(new Date(this.clockTargetDate)).next(-1).toYmd();
                this.dataAction = "update";
                listInfoList.push(this.currentMatter);

                this.tbListLine.forEach((item)=>{
                    if(item.linkInventoryId === this.inventoryId && item.startDate >= this.clockTargetDate){
                        listDeleteList.push({
                            deleteType: "inventory_branch",
                            branchInventoryId: this.inventoryId,
                            branchStartDate: item.startDate,
                            branchDataType: item.dataType,
                        })
                    }
                })
            }else{
                // 删除全部
                listDeleteList.push({
                    deleteType: "inventory",
                    deleteDataId: this.inventoryId,
                })
            }
            this.sendRequest(listInfoList, listDeleteList, [], []);
        },
        inquiryDelete: function(){
            this.deleteTitle = "清单";
            this.switchState('deleteState');
        },
        saveDelete: function(deleteType){
            if(this.deleteTitle === "清单"){
                // 删除清单
                this.deleteMatter(deleteType);
            }else{
                // 删除子任务
                this.currentChild.items.forEach((item, index, array)=>{
                    if(item.childId !== this.childItem.childId){
                        return
                    }
                    if(item.dataAction === "add"){
                        // 直接删除
                        array.splice(index, 1);
                    }else{
                        item.dataAction = "delete";
                    }
                })
            }
        },

        saveInfo: function(){
            // 处理
            this.deleteImageFile();

            if(this.createState){
                this.createMatter();
            }else{
                this.updateMatter();
            }
        },
        createMatter: function(){
            const matterItem = {
                categoryId: this.currentCategory.categoryId,
                categoryTitle: this.currentCategory.categoryTitle,
                color: this.currentViewColor.numberColor,
                createTimeStamp: Date.now(),
                crossDays: this.currentDateTime.crossDays,
                crossEndDate: this.currentDateTime.crossEndDate,
                dataAction: "add",
                deleteState: 0,
                endDate: this.currentRepeatEnd.endDate,
                endTime: this.currentDateTime.endTime,
                hasRepeatBranch: false,
                inventoryId: this.inventoryId,
                notes: this.currentNotes.text,
                notesImageUrls: this.currentImages.imageUrls,
                postponeDays: 0,
                priorityLevel: this.currentPriority.priorityLevel,
                remindTimes: this.currentRemind.remindTimes,
                repeatCycle: this.currentRepeat.repeatCycle,
                repeatDeleteDates: "",
                repeatEndInfo: this.currentRepeatEnd.repeatEndInfo,
                repeatEndType: this.currentRepeatEnd.repeatEndType,
                repeatInfo: this.currentRepeat.repeatInfo,
                repeatType: this.currentRepeat.repeatType,
                skipHolidaysState: this.currentRepeat.skipHolidaysState,
                sortNum: this.sortNum,
                startDate: this.currentDateTime.startDate,
                startTime: this.currentDateTime.startTime,
                timeOutAction: "",
                title: this.currentTitle.text,
                topState: false,
                userId: this.userId,
            };
            const listInfoList = [matterItem];
            const listChildList = this.currentChild.items
            this.sendRequest(listInfoList, listChildList, [], []);
        },

        usedAll: function(){
            const listInfoList = [];
            const listChildList = [];
            const listDeleteList = [];

            // 删除子线
            this.tbListLine.forEach((item)=>{
                if(item.linkInventoryId === this.inventoryId){
                    listDeleteList.push({
                        deleteType: "inventory_branch",
                        branchInventoryId: this.inventoryId,
                        branchStartDate: item.startDate,
                        branchDataType: item.dataType,
                    })
                }
            })
            this.currentMatter.title = this.currentTitle.text;
            this.currentMatter.notes = this.currentNotes.text;
            this.currentMatter.notesImageUrls = this.currentImages.imageUrls;
            this.currentMatter.hasRepeatBranch = false;

            this.setMatterInfo();
            listInfoList.push(this.currentMatter);
            this.getChildItems(listChildList);
            this.sendRequest(listInfoList, listChildList, [], listDeleteList);
        },
        usedToday: function(){
            const listInfoList = [];
            const listLineList = [];
            const listChildList = [];
            const lineItemArray = this.tbListLine.filter((item)=>{
                return item.linkInventoryId === this.inventoryId
                    && item.startDate === this.clockTargetDate
                    && item.dataType === 1
            })

            let lineItem;
            if(lineItemArray.length === 0){
                // 创建时间线
                lineItem = {
                    linkInventoryId: this.inventoryId,
                    userId: this.userId,
                    startDate: this.clockTargetDate,
                    dataType: 1,
                    title: this.currentTitle.text,
                    notes: this.currentNotes.text,
                    notesUrls: this.currentImages.imageUrls,
                    dataAction: "add"
                }
                if(!this.currentMatter.hasRepeatBranch){
                    this.currentMatter.hasRepeatBranch = true;
                }
            }else{
                // 更新时间线
                lineItem = JSON.parse(JSON.stringify(lineItemArray[0]));
                lineItem.title = this.currentTitle.text;
                lineItem.notes = this.currentNotes.text;
                lineItem.notesUrls = this.currentImages.imageUrls;
                lineItem.dataAction = "update";
            }
            listLineList.push(lineItem);

            this.setMatterInfo();
            this.currentMatter.dataAction = "update";

            listInfoList.push(this.currentMatter);
            this.getChildItems(listChildList);
            this.sendRequest(listInfoList, listChildList, listLineList, []);
        },
        usedAfter: function(){
            const listInfoList = [];
            const listLineList = [];
            const listChildList = [];
            const listDeleteList = [];
            const lineItemArray = this.tbListLine.filter((item)=>{
                return item.linkInventoryId === this.inventoryId
                    && item.startDate === this.clockTargetDate
                    && item.dataType === 0
            })
            let lineItem;
            if(lineItemArray.length === 0){
                // 创建时间线
                lineItem = {
                    linkInventoryId: this.inventoryId,
                    userId: this.userId,
                    startDate: this.clockTargetDate,
                    dataType: 0,
                    title: this.currentTitle.text,
                    notes: this.currentNotes.text,
                    notesUrls: this.currentImages.imageUrls,
                    dataAction: "add"
                }
                if(!this.currentMatter.hasRepeatBranch){
                    this.currentMatter.hasRepeatBranch = true;
                }
            }else{
                // 更新时间线
                lineItem = JSON.parse(JSON.stringify(lineItemArray[0]));
                lineItem.title = this.currentTitle.text;
                lineItem.notes = this.currentNotes.text;
                lineItem.notesUrls = this.currentImages.imageUrls;
                lineItem.dataAction = "update";
            }
            listLineList.push(lineItem);
            this.tbListLine.forEach((item)=>{
                if(item.linkInventoryId !== this.inventoryId){
                    return
                }
                if((item.startDate === this.clockTargetDate && item.dataType === 1 )
                    || item.startDate > this.clockTargetDate){
                    listDeleteList.push({
                        deleteType: "inventory_branch",
                        branchInventoryId: this.inventoryId,
                        branchStartDate: item.startDate,
                        branchDataType: item.dataType,
                    })
                }
            })
            this.currentMatter.dataAction = "update";

            this.setMatterInfo();
            listInfoList.push(this.currentMatter);
            this.getChildItems(listChildList);
            this.sendRequest(listInfoList, listChildList, listLineList, listDeleteList);
        },
        setMatterInfo: function(){
            this.currentMatter.startDate = this.currentDateTime.startDate;
            this.currentMatter.endDate = this.currentRepeatEnd.endDate;
            this.currentMatter.crossEndDate = this.currentDateTime.crossEndDate;
            this.currentMatter.crossDays = this.currentDateTime.crossDays;
            this.currentMatter.startTime = this.currentDateTime.startTime;
            this.currentMatter.endTime = this.currentDateTime.endTime;
            this.currentMatter.categoryId = this.currentCategory.categoryId;
            this.currentMatter.categoryTitle = this.currentCategory.categoryTitle;
            this.currentMatter.priorityLevel = this.currentPriority.priorityLevel;
            this.currentMatter.color = this.currentViewColor.numberColor;
            this.currentMatter.repeatType = this.currentRepeat.repeatType;
            this.currentMatter.repeatCycle = this.currentRepeat.repeatCycle;
            this.currentMatter.repeatInfo = this.currentRepeat.repeatInfo;
            this.currentMatter.skipHolidaysState = this.currentRepeat.skipHolidaysState;
            this.currentMatter.repeatEndType = this.currentRepeatEnd.repeatEndType;
            this.currentMatter.repeatEndInfo = this.currentRepeatEnd.repeatEndInfo;
            this.currentMatter.remindTimes = this.currentRemind.remindTimes;
            if(this.currentRepeat.repeatType === ""){
                this.currentMatter.repeatDeleteDates = "";
            }
            this.currentMatter.dataAction = "update";
        },
        getChildItems: function(listChildList, listDeleteList){

            this.currentChild.items.forEach((item)=>{
                if(item.dataAction === "add" || item.dataAction === "update"){
                    listChildList.push(item)
                }else if(item.dataAction === "delete"){
                    listDeleteList.push({
                        deleteType: "",
                        deleteDataId: item.child,
                    })
                }
            })
        },
        saveUpdate: function(e){
            if(e === 0){
                // 进当日
                this.usedToday();
            }else if(e === 1){
                // 当日及以后
                this.usedAfter();
            }else{
                // 全部
                this.usedAll();
            }
        },
        updateMatter: function(){
            // 询问 重复  标题 备注有修改
            if(this.currentMatter.repeatType !== ""){
                // 重复
                if(this.currentRepeat.repeatType === ""){
                    // 非重复 应用于主线
                    this.usedAll();
                }else if(this.currentTitle.updated || this.currentNotes.updated || this.currentImages.updated){
                    // 询问
                    this.moduleState.updateState = true;
                }else if(this.currentDateTime.updated || this.currentRemind.updated || this.currentRepeat.updated
                    || this.currentRepeatEnd.updated || this.currentCategory.updated || this.currentChild.updated
                    ||this.currentPriority.updated || this.currentViewColor.updated){
                    // 修改基础信息
                    this.setMatterInfo();
                    const listInfoList = [];
                    const listChildList = [];

                    listInfoList.push(this.currentMatter);
                    this.getChildItems(listChildList);
                    this.sendRequest(listInfoList, listChildList, [], []);
                }else{
                    // 未修改
                    this.close();
                }
            }else if(this.currentTitle.updated || this.currentNotes.updated || this.currentImages.updated
                || this.currentDateTime.updated || this.currentRemind.updated || this.currentRepeat.updated
                || this.currentRepeatEnd.updated || this.currentCategory.updated || this.currentChild.updated
                ||this.currentPriority.updated || this.currentViewColor.updated){
                this.currentMatter.title = this.currentTitle.text;
                this.currentMatter.notes = this.currentNotes.text;
                this.currentMatter.notesImageUrls = this.currentImages.imageUrls;
                this.setMatterInfo();
                const listInfoList = [];
                const listChildList = [];

                listInfoList.push(this.currentMatter);
                this.getChildItems(listChildList);
                this.sendRequest(listInfoList, listChildList, [], []);
            }else{
                // 未修改
                this.close();
            }
        },
        sendRequest: function(listInfoList, listChildList, listTimeLineList, listDeleteList){
            const that = this;

            const params = {
                optId: this.optId,
                listInfoList: listInfoList,
                listClockList: [],
                listCategoryList: [],
                listChildList: listChildList,
                listTimeLineList: listTimeLineList,
                listDeleteList: listDeleteList,
            }

            this.setLoading(true);
            this.$api.getSyncList(params).then((res)=>{
                that.setLoading(false);
                if(res.data.code === 200 && !res.data.data.differenceData){
                    that.setList(listInfoList);
                    that.setLine(listTimeLineList);
                    that.setChild(listChildList);
                    that.setDeleteData(listDeleteList);

                    that.setOptId(res.data.data.lastOptId);
                    that.submit();
                }else{
                    that.$PopupToast("保存失败");
                }
                that.close();
            })
        },
        /**
         * vip限制： 检查清单备注图片数量
         * 注：非会员限制1张 会员限制5张
         * @returns {boolean}
         */
        checkMatterImageNumber: function(){
            let maxImageLength;
            if(this.vipInfo.userRole === "vip"){
                maxImageLength = 5;
            }else{
                maxImageLength = 1;
            }
            return this.currentImages.imageFiles.length >= maxImageLength
        },

    },
    mounted(){
        if(this.matterItem.info){
            // 更新
            this.createState = false;
            this.inventoryId = this.matterItem.info.inventoryId;
            // 初始化信息
            this.initSettingInfo();

        }else{
            // 新建
            this.createState = true;
            this.inventoryId = this.$Utils.get_uuid();
            let sortNum;
            if(this.tbListInfo.length === 0){
                sortNum = 10;
            }else{
                sortNum = this.tbListInfo[0].sortNum + 10;
            }
            this.sortNum = sortNum;
            // 设置开始日期
            if(!this.waitState){
                this.initDateTime({
                    startDate: this.clockTargetDate,
                    crossEndDate: "",
                    crossDays: 0,
                    startTime: -1,
                    endTime: -1,
                })
            }
            // 随机视图颜色
            const indexColor = Math.floor(Math.random() * 100) % 30;
            this.saveViewColor(initData.viewColor[indexColor]);
            this.currentViewColor.updated = false;
        }
        if(this.vipInfo.userRole === "normal" && this.currentDateTime.crossEndDate === ""){
            // 非会员 非跨天
            const crossArray = this.tbListInfo.filter((item)=>{
                return item.crossEndDate !== ""
            })
            this.allowCross = crossArray.length === 0;
        }
    },
}
</script>

<style scoped>
div.body-matter-info{
    width: 8rem;
    height: 100%;
    background: #FFFFFF;
    position: absolute;
    right: 0;
    box-sizing: border-box;
    padding: 0 0.36rem 0.3rem;
    display: flex;
    flex-direction: column;
}
div.scroll-items{
    flex: 1;
    overflow-y: scroll;
    margin-bottom: 0.1rem;
}
div.info-title{
    width: 100%;
    height: 0.55rem;
    position: relative;
    display: flex;
    justify-content: center;
}
img.icon-back{
    width: 0.27rem;
    height: 0.27rem;
    position: absolute;
    top: 0.14rem;
    left: 0;
}
div.item-category{
    display: inline-flex;
    align-items: center;
    gap: 0.07rem;
}
div.text-category{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}
img.icon-put-open{
    width: 0.14rem;
    height: 0.14rem;
}
div.matter-title{
    width: 100%;
    height: 0.4rem;
}
input.matter-title{
    height: 100%;
    width: 100%;
    display: block;
    padding: 0;

    font-weight: bold;
    font-size: 0.22rem;
    line-height: 0.26rem;
    color: #000000;
    text-align: left;
}
input.matter-title::placeholder{
    color: rgba(0, 0, 0, 0.7);
}
div.setting-items{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    column-gap: 0.24rem;
    row-gap: 0.12rem;
    flex-wrap: wrap;
    padding: 0.24rem 0 0.24rem 0.4rem;
}
div.item-setting{
    min-width: 1.1rem;
    max-width: calc(100% - 0.24rem);
    height: 0.36rem;
    padding: 0 0.1rem;

    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    line-height: 0.32rem;
    text-align: center;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    border: 0.02rem solid #000000;
    border-radius: 0.24rem;

    box-sizing: border-box;
    flex-basis: auto;
}
div.matter-child{
    display: flex;
    flex-direction: column;
}

div.row-child-item, div.matter-priority, div.matter-view-color{
    width: 100%;
    height: 0.46rem;
    display: flex;
    gap: 0.1rem;
    align-items: center;
}


img.item-icon{
    width: 0.24rem;
    height: 0.24rem;
}
input.child-title{
    width: 6.42rem;
    padding: 0;
    line-height: 0.46rem;

    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
}
div.child-submit{
    font-weight: bold;
    font-size: 0.16rem;
    color: #FC8470;
    line-height: 0.19rem;
    text-align: right;
}
div.child-submit,img.child-delete{
    margin-left: auto;
}

div.text-title, div.text-priority{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    text-align: left;
}
div.matter-color, div.text-priority{
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 0.1rem;
}
img.icon-put-away{
    width: 0.14rem;
    height: 0.14rem;
}

div.view-color{
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    border: 0.02rem solid #000000;
    box-sizing: border-box;
    background: #DAD7F6;
}
div.matter-mark{
    width: 100%;
    border: 0.02rem solid #000000;
    border-radius: 0.2rem;
    box-sizing: border-box;
    padding: 0.18rem 0.24rem;
    margin-top: 0.16rem;
}
textarea#matter-mark{
    width: 100%;
    height: 1.26rem;
    resize: none;
    font-size:.18rem;
    font-weight: bold;
    color: #000000;
    font-family:PF-Regular,sans-serif;
    line-height: 0.22rem;
    text-align: justify;
    box-sizing:border-box;
    position: relative;
}
textarea#matter-mark::placeholder{
    color: rgba(0, 0, 0, 0.7);
}
div.image-add-tip{
    width: 100%;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: left;
    display: flex;
    align-items: center;
    gap: 0.1rem;
    margin-top: 0.1rem;
}
img.icon-add-tip{
    width: .24rem;
    height: .24rem;
}
div.mark-images{
    width: 100%;
    margin-top: 0.1rem;
    display: flex;
    gap: 0.18rem;
}

div.image-add{
    width: 0.54rem;
    height: 0.54rem;
    border-radius: 0.1rem;
    border: 0.02rem solid #000000;
    box-sizing: border-box;
    background: url("../../../assets/images/List/icon-info-img-add.png") center center no-repeat;
    background-size: 0.18rem 0.18rem;
}
div.item-image{
    position: relative;
}
div.icon-image-delete{
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    background: url("../../../assets/images/Public/icon-clear.png");
    background-size: cover;

    top: -0.1rem;
    right: -0.1rem;
    position: absolute;
}
div.bottom-items{
    width: 100%;
    height: 0.52rem;
    display: flex;
    gap: 0.2rem;
}
div.item-submit{
    flex: 1;
    height: 100%;
    border-radius: 0.08rem;
    border: 0.02rem solid #000000;
    box-sizing: border-box;

    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    line-height: 0.48rem;
    text-align: center;
}
div.item-submit:nth-last-of-type(1){
    background: #FEE494;
}
</style>